import { IWorkspaceColumnOverride } from '../@types/workspaceTypes';
import { useSelector } from 'react-redux';
import { CostViewPermission } from '../graphql/schema/p4types';
import { useMemo } from 'react';
import { usePrecision } from './hooks';

export const useAbstractSalesHeaderColumnOverrides = (
  baseColumnOverrides: IWorkspaceColumnOverride
): IWorkspaceColumnOverride => {
  const costViewPermission =
    useSelector((store: any) => store.app?.fullUserDetails?.companyUser?.costViewPermission) ?? CostViewPermission.None;

  return useMemo(() => {
    if (costViewPermission === CostViewPermission.Haggle) {
      return {
        ...baseColumnOverrides,
        baseCostTotal: {
          disabled: true,
        },
        costTotal: {
          disabled: true,
        },
        baseProfitValue: {
          disabled: true,
        },
        profitValue: {
          disabled: true,
        },
        profitMargin: {
          disabled: true,
        },
        haggleCostTotal: {
          name: 'Cost Total',
        },
        haggleProfitValue: {
          name: 'Profit Value',
        },
        haggleProfitMargin: {
          name: 'Profit Margin',
        },
        baseHaggleCostTotal: {
          name: 'Base Cost Total',
        },
        baseHaggleProfitValue: {
          name: 'Base Profit Value',
        },
      };
    } else if (costViewPermission === CostViewPermission.None) {
      return {
        ...baseColumnOverrides,
        baseCostTotal: {
          disabled: true,
        },
        costTotal: {
          disabled: true,
        },
        baseProfitValue: {
          disabled: true,
        },
        profitValue: {
          disabled: true,
        },
        profitMargin: {
          disabled: true,
        },
        haggleCostTotal: {
          disabled: true,
        },
        haggleProfitValue: {
          disabled: true,
        },
        haggleProfitMargin: {
          disabled: true,
        },
        baseHaggleCostTotal: {
          disabled: true,
        },
        baseHaggleProfitValue: {
          disabled: true,
        },
      };
    }
    return baseColumnOverrides;
  }, [baseColumnOverrides, costViewPermission]);
};

export const useAbstractSalesLineColumnOverrides = (
  baseColumnOverrides: IWorkspaceColumnOverride,
  costPricePrecision: number,
  sellingPricePrecision: number
): IWorkspaceColumnOverride => {
  const costViewPermission =
    useSelector((store: any) => store.app?.fullUserDetails?.companyUser?.costViewPermission) ?? CostViewPermission.None;

  return useMemo(() => {
    if (costViewPermission === CostViewPermission.Haggle) {
      return {
        ...baseColumnOverrides,
        costPrice: {
          disabled: true,
        },
        singleUnitCostPrice: {
          disabled: true,
        },
        lineCost: {
          disabled: true,
        },
        profitValue: {
          disabled: true,
        },
        lineProfitValue: {
          disabled: true,
        },
        baseLineProfitValue: {
          disabled: true,
        },
        singleUnitProfitValue: {
          disabled: true,
        },
        profitMargin: {
          disabled: true,
        },
        baseLineCost: {
          disabled: true,
        },
        haggleCostPrice: {
          name: 'Cost Price',
          options: { format: { decimals: costPricePrecision } },
        },
        singleUnitHaggleCostPrice: {
          name: 'Single Unit Cost Price',
          options: { format: { decimals: costPricePrecision } },
        },
        haggleLineCost: {
          name: 'Line Cost',
          options: {
            format: { decimals: costPricePrecision },
          },
        },
        haggleProfitValue: {
          name: 'Profit Value',
          options: { format: { decimals: sellingPricePrecision } },
        },
        singleUnitHaggleProfitValue: {
          name: 'Single Unit Profit Value',
          options: { format: { decimals: sellingPricePrecision } },
        },
        haggleProfitMargin: {
          name: 'Profit Margin',
        },
        haggleLineProfitValue: {
          name: 'Line Profit Value',
        },
      };
    } else if (costViewPermission === CostViewPermission.None) {
      return {
        ...baseColumnOverrides,
        costPrice: {
          disabled: true,
        },
        singleUnitCostPrice: {
          disabled: true,
        },
        lineCost: {
          disabled: true,
        },
        profitValue: {
          disabled: true,
        },
        lineProfitValue: {
          disabled: true,
        },
        haggleLineProfitValue: {
          disabled: true,
        },
        baseLineProfitValue: {
          disabled: true,
        },
        singleUnitProfitValue: {
          disabled: true,
        },
        profitMargin: {
          disabled: true,
        },
        haggleCostPrice: {
          disabled: true,
        },
        singleUnitHaggleCostPrice: {
          disabled: true,
        },
        haggleLineCost: {
          disabled: true,
        },
        haggleProfitValue: {
          disabled: true,
        },
        singleUnitHaggleProfitValue: {
          disabled: true,
        },
        haggleProfitMargin: {
          disabled: true,
        },
        costUnitDescription: {
          disabled: true,
        },
        costUnitQuantity: {
          disabled: true,
        },
        costPricePrecision: {
          disabled: true,
        },
        baseLineCost: {
          disabled: true,
        },
      };
    }
    return baseColumnOverrides;
  }, [baseColumnOverrides, costViewPermission, costPricePrecision, sellingPricePrecision]);
};
